module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tag-select"
  }, [_c('v-select', {
    attrs: {
      "multiple": "",
      "taggable": _vm.canCreate,
      "filterable": false,
      "closeOnSelect": false,
      "options": _vm.results,
      "createOption": _vm.createOption,
      "value": _vm.labeledValue,
      "placeholder": _vm.placeholder
    },
    on: {
      "search": _vm.doSearch,
      "input": _vm.onInput
    },
    nativeOn: {
      "keyup": function($event) {
        _vm.handleEmptySearch($event)
      }
    }
  }, [_c('template', {
    attrs: {
      "slot": "no-options"
    },
    slot: "no-options"
  }, [_vm._v("\n      Search tags...\n    ")])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ba8715c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/tag-select/index.vue
// module id = 2040
// module chunks = 2